import React from "react";

const Pagination = ({ page, totalPages, onChange }) => {
    if (!totalPages || totalPages <= 1) return null;
    const go = (p) => onChange(Math.min(Math.max(1, p), totalPages));

    const window = [];
    const start = Math.max(1, page - 2);
    const end = Math.min(totalPages, page + 2);
    for (let i = start; i <= end; i++) window.push(i);

    return (
        <nav className="pagination">
            <button
                className="pagination-btn"
                disabled={page === 1}
                onClick={() => go(page - 1)}
            >
                ‹ Prev
            </button>
            {start > 1 && (
                <>
                    <button className="pagination-btn" onClick={() => go(1)}>1</button>
                    <span className="pagination-ellipsis">…</span>
                </>
            )}
            {window.map((p) => (
                <button
                    key={p}
                    className={"pagination-btn" + (p === page ? " active" : "")}
                    onClick={() => go(p)}
                >
                    {p}
                </button>
            ))}
            {end < totalPages && (
                <>
                    <span className="pagination-ellipsis">…</span>
                    <button className="pagination-btn" onClick={() => go(totalPages)}>{totalPages}</button>
                </>
            )}
            <button
                className="pagination-btn"
                disabled={page === totalPages}
                onClick={() => go(page + 1)}
            >
                Next ›
            </button>
        </nav>
    );
};

export default Pagination;
